/* HUD hämtningsrad v5 (förhandsvisning 2026-10-25). Bygger på v4.
   En textrad "Finns att hämta i butik" + "Se butiker" (popup med båda butikerna, "Hitta till oss").
   v5: hämtningsstatus använder aldrig ordet "lager". Kan varan inte hämtas: "Hämtning för närvarande inte tillgänglig".
   Texterna kommer från snippeten (data-hud-pl-texts, per språk); reservtexter nedan är svenska.
   Status för vald variant från Simesy get_variant_locations (publik, ingen nyckel). Regler oförändrade från v3/v4:
   - antal > 0 på en butiksplats (aktiv, lagerförd) => available där
   - paket (tagg "Bundle 1-2"): available i Kungälv om varianten är köpbar och policy = deny (ingen förbeställning)
   - annars: lagerförs inte => unknown; policy CONTINUE och köpbar => unavailable (orsak preorder); annars unavailable (orsak out)
   - fel/timeout (8 s) => unknown ("Kontakta butiken om hämtning")
   OBS: målet är att förbeställningsvaror inte ska visa hämtningsraden alls (Parts utreder). Inget byggt för det i v5.
   Popup: <dialog> showModal, aria-modal, fokusfälla, Esc, klick utanför, Stäng-knapp, scroll-lås, fokus tillbaka.
   Ordningsvakt: raden ska ligga efter Simesy-blocket "Leverans" (Simesys kod ändras inte).
   v6 (2026-10-26): popupen ser ut som temats upphämtningspanel; JS-ändring endast variantrad + variantbild i paint(). */
(function () {
  'use strict';
  if (window.__hudPickupLineV5) return;
  window.__hudPickupLineV5 = true;

  var STORES = [
    { id: '85839511877', name: 'Racingshop Kungälv' },
    { id: '86155002181', name: 'Racingshop Göteborg (popup-butik hos Gokartcentralen Göteborg)' }
  ];
  var KUNGALV = STORES[0].id;
  /* Reservtexter (sv). Riktiga texter per språk läses från snippeten i init(). Inget ord om "lager". */
  var DEF = {
    available: 'Finns att hämta i butik',
    unavailable: 'Hämtning för närvarande inte tillgänglig',
    unknown: 'Kontakta butiken om hämtning',
    loading: 'Kollar hämtning i butik…',
    store_available: 'Kan hämtas här',
    store_loading: 'Kollar hämtning…',
    see: 'Se butiker'
  };
  function txt(box) { return box.__hplT || DEF; }
  function lineText(T, st) { return T[st] || T.unknown; }
  function storeText(T, st) {
    if (st === 'available') return T.store_available;
    if (st === 'loading') return T.store_loading;
    return T[st] || T.unknown;
  }
  var API = 'https://sales-boost.simesy.com/api/get_variant_locations';
  var cache = {};

  function gidNum(g) { return String(g || '').split('/').pop(); }

  function fetchLocations(shop, variantId) {
    if (cache[variantId]) return cache[variantId];
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var t = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
    var p = fetch(API + '?shop=' + encodeURIComponent(shop) + '&variantId=' + encodeURIComponent(variantId), {
      credentials: 'omit', signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      if (!j || j.success !== true || !Array.isArray(j.data)) throw new Error('bad data');
      return j.data;
    }).finally(function () { if (t) clearTimeout(t); });
    p.catch(function () { delete cache[variantId]; });
    cache[variantId] = p;
    return p;
  }

  /* Status per butik (oförändrad logik från v3). locs = Simesy-data (null vid fel). v = {a,d,m,t} från Liquid. */
  function computeStatus(locs, v, bundle) {
    var out = {};
    if (!locs) { STORES.forEach(function (s) { out[s.id] = 'unknown'; }); return out; }
    var anyPolicy = null;
    STORES.forEach(function (s) {
      var l = null;
      for (var i = 0; i < locs.length; i++) if (gidNum(locs[i].id) === s.id) { l = locs[i]; break; }
      if (l && l.inventoryPolicy) anyPolicy = l.inventoryPolicy;
      if (l && l.isActive !== false && l.tracked === true && Number(l.quantity) > 0) out[s.id] = 'available';
    });
    if (!anyPolicy) for (var k = 0; k < locs.length; k++) if (locs[k].inventoryPolicy) { anyPolicy = locs[k].inventoryPolicy; break; }
    var tracked = v ? v.m === 1 : locs.some(function (l) { return l.tracked === true; });
    var cont = v ? v.d === 0 : anyPolicy === 'CONTINUE';
    var buyable = v ? v.a === 1 : true;
    if (bundle && v && v.a === 1 && v.d === 1 && !out[KUNGALV]) out[KUNGALV] = 'available';
    STORES.forEach(function (s) {
      if (out[s.id]) return;
      /* preorder och out visas båda som "Hämtning för närvarande inte tillgänglig". */
      if (!tracked) out[s.id] = 'unknown';
      else if (cont && buyable) { out[s.id] = 'unavailable'; out['_reason_' + s.id] = 'preorder'; }
      else { out[s.id] = 'unavailable'; out['_reason_' + s.id] = 'out'; }
    });
    return out;
  }

  /* Raden: hämtbar i minst en butik vinner; annars inte tillgänglig > okänd. */
  function lineStatus(st) {
    if (!st) return 'loading';
    var vals = STORES.map(function (s) { return st[s.id]; });
    var order = ['available', 'unavailable', 'unknown'];
    for (var i = 0; i < order.length; i++) if (vals.indexOf(order[i]) !== -1) return order[i];
    return 'unknown';
  }

  function paint(box, st, stateName) {
    box.__hplStatus = st;
    var ls = lineStatus(st);
    box.setAttribute('data-status', ls);
    box.setAttribute('data-state', stateName);
    var T = txt(box);
    var s = box.querySelector('[data-hud-pl-status]');
    if (s) s.textContent = lineText(T, ls);
    var btn = box.querySelector('[data-hud-pl-open]');
    if (btn) btn.setAttribute('aria-label', T.see + ' – ' + lineText(T, ls).replace('…', '') + ' – Kungälv, Göteborg');
    var d = box.__hplDialog;
    if (d) {
      STORES.forEach(function (store) {
        var li = d.querySelector('.hud-pl-dialog__store[data-store="' + store.id + '"]');
        if (!li) return;
        var stat = st ? st[store.id] : 'loading';
        var p = li.querySelector('[data-hud-pl-store-status]');
        if (p) p.setAttribute('data-status', stat);
        var t = li.querySelector('[data-hud-pl-store-text]');
        if (t) t.textContent = storeText(T, stat);
      });
      var vId = box.__hplVariant;
      var v = (box.__hplVariants || {})[vId];
      var vt = v && v.t && v.t !== 'Default Title' ? v.t : '';
      /* v6: titel står separat i panelen; här visas bara varianten (t.ex. "L") + variantbild om den finns. */
      var vp = d.querySelector('[data-hud-pl-variant]');
      if (vp) { vp.textContent = vt; vp.hidden = !vt; }
      var im = d.querySelector('[data-hud-pl-img]');
      if (im && v) { var src = v.i || im.getAttribute('data-fallback'); if (src && im.getAttribute('src') !== src) im.setAttribute('src', src); }
    }
  }

  function update(box, variantId) {
    if (!variantId) return;
    variantId = String(variantId);
    if (box.__hplVariant === variantId) return;
    box.__hplVariant = variantId;
    box.setAttribute('data-variant-id', variantId);
    var v = (box.__hplVariants || {})[variantId];
    var bundle = box.getAttribute('data-bundle') === '1';
    paint(box, null, 'loading');
    fetchLocations(box.getAttribute('data-shop'), variantId).then(function (locs) {
      if (box.__hplVariant !== variantId) return;
      var st = computeStatus(locs, v, bundle);
      paint(box, st, 'Kungälv:' + st[STORES[0].id] + ',Göteborg:' + st[STORES[1].id]);
    }).catch(function () {
      if (box.__hplVariant !== variantId) return;
      paint(box, computeStatus(null, v, bundle), 'error');
    });
  }

  /* ---------- Ordningsvakt: raden efter Simesy-blocket (samma princip som v3) ---------- */
  function ensureAfterSimesy(box) {
    var simBlock = document.querySelector('[id*="sm_estimated_delivery_date"]');
    if (!simBlock) return; /* Simesy saknas: raden ligger kvar där blocket står i mallen. */
    var simWrap = simBlock.closest('.product-info-block') || simBlock;
    var boxWrap = box.closest('.product-info-block') || box;
    if (simWrap === boxWrap || simWrap.contains(boxWrap) || boxWrap.contains(simWrap)) return;
    if (boxWrap.compareDocumentPosition(simWrap) & Node.DOCUMENT_POSITION_FOLLOWING) {
      simWrap.parentNode.insertBefore(boxWrap, simWrap.nextSibling);
      box.setAttribute('data-moved', '1');
    }
  }

  /* ---------- Popup ---------- */
  var openBox = null, lastFocus = null, savedOverflow = null;

  function focusables(d) {
    return Array.prototype.filter.call(d.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (x) {
      return x.offsetParent !== null || x === document.activeElement;
    });
  }

  function wireDialog(box) {
    var d = box.querySelector('dialog.hud-pl-dialog');
    if (!d) return null;
    /* Flytta till <body> så att temats layout (overflow/transform/sticky) aldrig påverkar popupen. */
    if (document.getElementById(d.id) !== d || d.parentNode !== document.body) {
      if (document.querySelectorAll('#' + d.id).length > 1) d.id = d.id + '-' + Math.random().toString(36).slice(2, 7);
      document.body.appendChild(d);
    }
    var btn = box.querySelector('[data-hud-pl-open]');
    if (btn) btn.setAttribute('aria-controls', d.id);
    d.addEventListener('click', function (e) {
      if (e.target === d || (e.target.closest && e.target.closest('[data-hud-pl-close]'))) closeDialog();
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDialog(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(d);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      var inside = d.contains(document.activeElement);
      if (e.shiftKey && (document.activeElement === first || !inside)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !inside)) { e.preventDefault(); first.focus(); }
    });
    return d;
  }

  function openDialog(box, opener) {
    var d = box.__hplDialog;
    if (!d) return;
    paint(box, box.__hplStatus || null, box.getAttribute('data-state') || 'loading');
    openBox = box;
    lastFocus = opener || document.activeElement;
    savedOverflow = [document.documentElement.style.overflow, document.body.style.overflow];
    document.documentElement.classList.add('hud-pl-lock');
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    var c = d.querySelector('[data-hud-pl-close]'); if (c) c.focus();
    if (opener) opener.setAttribute('aria-expanded', 'true');
  }

  function closeDialog() {
    if (!openBox) return;
    var d = openBox.__hplDialog;
    if (d) { if (typeof d.close === 'function' && d.open) d.close(); else d.removeAttribute('open'); }
    document.documentElement.classList.remove('hud-pl-lock');
    if (savedOverflow) { document.documentElement.style.overflow = savedOverflow[0]; document.body.style.overflow = savedOverflow[1]; savedOverflow = null; }
    if (lastFocus) { if (lastFocus.setAttribute) lastFocus.setAttribute('aria-expanded', 'false'); if (lastFocus.focus) lastFocus.focus(); }
    openBox = null;
  }

  /* ---------- Variantbyte ---------- */
  function currentVariantId(box) {
    var scope = box.closest('product-info, .product-info, section') || document;
    var input = scope.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input && input.value ? input.value : null;
  }

  function init(box) {
    if (box.__hplInit) return;
    box.__hplInit = true;
    try {
      var tj = box.querySelector('[data-hud-pl-texts]');
      var tt = tj ? JSON.parse(tj.textContent) : null;
      if (tt && tt.available && tt.unavailable && tt.unknown) {
        box.__hplT = {};
        for (var key in DEF) box.__hplT[key] = tt[key] || DEF[key];
      }
    } catch (e) { box.__hplT = null; }
    try {
      var j = box.querySelector('[data-hud-pl-variants]');
      box.__hplVariants = j ? JSON.parse(j.textContent) : {};
    } catch (e) { box.__hplVariants = {}; }
    box.__hplDialog = wireDialog(box);
    var btn = box.querySelector('[data-hud-pl-open]');
    if (btn) btn.addEventListener('click', function () { openDialog(box, btn); });
    ensureAfterSimesy(box);
    update(box, box.getAttribute('data-variant-id'));
  }

  function all(fn) {
    var boxes = document.querySelectorAll('[data-hud-pl]');
    for (var i = 0; i < boxes.length; i++) fn(boxes[i]);
  }

  function onVariant(id) { all(function (b) { init(b); update(b, id || currentVariantId(b)); }); }

  all(init);
  window.addEventListener('load', function () { all(ensureAfterSimesy); });
  [2000, 6000, 12000].forEach(function (ms) { setTimeout(function () { all(ensureAfterSimesy); }, ms); });
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
      var v = e && e.data && e.data.variant;
      if (v && v.id) onVariant(v.id);
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.name === 'id' || t.closest('variant-selects, variant-radios, .product-variant-picker, .product-form')) {
      setTimeout(function () { onVariant(null); }, 350);
    }
  }, true);
  window.addEventListener('popstate', function () { setTimeout(function () { onVariant(null); }, 350); });
})();
